/*
 * Author M. Atoar Rahman
 * Title: Dispensary Stock Return
 * Description: Page for Dispensary Stock Return
 * Date: 19/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { DispensaryStockReturnProvider } from '../dispensary/stockReturn/ContextAPI';
import Index from '../dispensary/stockReturn/Index';
import PermissionDenied from './PermissionDenied';

export default function DispensaryStockReturn() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['dispensary-stock-return']) return <PermissionDenied />;

    return (
        <DispensaryStockReturnProvider>
            <Index />
        </DispensaryStockReturnProvider>
    );
}
